import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { switchMap } from 'rxjs/operators';
import { Observable, from, EMPTY } from 'rxjs';

@Injectable()
export class AccountInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if the request has a custom header "X-Skip-Account-Interceptor"
    if (req.headers.has('X-Skip-Account-Interceptor')) {
      // If the custom header is present, skip the AccountInterceptor
      console.log('Skipping AccountInterceptor for this request.', req.url);
      return next.handle(req);
    }

    // Get the accountid from the AuthService asynchronously
    return from(this.authService.getSelectedAccountId()).pipe(
      switchMap((accountid) => {
        if (!accountid) {
          // If there is no accountid, effectively "drop" the request by not proceeding
          console.log('No selected account. Dropping the request.', req.url);
          return EMPTY; // Return an Observable that immediately completes
        }
        
        // Clone the request and add the accountid header to the clone
        const authReq = req.clone({
          headers: req.headers.set('accountid', accountid),
        });

        // Pass the clone request to the next interceptor in the chain
        return next.handle(authReq);
      })
    );
  }

  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   // Check if the request has a custom header "X-Skip-Account-Interceptor"
  //   if (req.headers.has('X-Skip-Account-Interceptor')) {
  //     // If the custom header is present, skip the AccountInterceptor
  //     console.log('Skipping AccountInterceptor for this request.', req.url);
  //     return next.handle(req);
  //   }

  //   // Get the accountid from the AuthService asynchronously
  //   return from(this.authService.getSelectedAccountId()).pipe(
  //     switchMap((accountid) => {
  //       // Clone the request and add the accountid header to the clone
  //       const authReq = req.clone({
  //         headers: req.headers.set('accountid', accountid),
  //       });

  //       // Pass the clone request to the next interceptor in the chain
  //       return next.handle(authReq);
  //     })
  //   );
  // }
}
